// Public Stripe Payment Links, configured separately for each complete plan period.
// Leave empty until the corresponding EUR amount and duration are verified in Stripe.
export const personalCare360PaymentLinks = {
    twelveMonths: '',
    twentyFourMonths: '',
    thirtySixMonths: ''
};
export const smartCarePaymentLinks = {
    sixMonths: '',
    twelveMonths: '',
    thirtySixMonths: '',
    sixtyMonths: ''
};
export const totalCareVipPaymentLinks = {
    sixMonths: '',
    twelveMonths: '',
    thirtySixMonths: '',
    sixtyMonths: ''
};
export const oneOffInterventionPaymentLink = '';
